var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_9972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.229584 80.9381V84.5745V88.2108H3.86595V84.5745H7.50231V80.9381H3.86595H0.229584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86595 37.302H7.50231V33.6656H3.86595H0.229584V37.302V40.9384H3.86595V37.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50231 26.3929H25.6841V0.938354H0.229584V26.3929H7.50231ZM3.86595 19.1202V4.57472H22.0478V22.7565H3.86595V19.1202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50239 51.8473H11.1388V48.2109H14.7751H18.4115V44.5746H14.7751H11.1388H7.50239H3.86603V48.2109H7.50239V51.8473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1387 37.3019H7.50232V40.9382H11.1387V37.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1387 102.756H7.50232V106.393V110.029V113.665H11.1387H14.775H18.4114V110.029V106.393V102.756H14.775H11.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.775 62.756V59.1197H11.1387V55.4833H3.86595V48.2106H0.229584V73.6651H3.86595V77.3015H7.50231V80.9378H14.775V77.3015H11.1387V73.6651H14.775V70.0288H18.4114V66.3924H14.775V62.756ZM11.1387 70.0288H7.50231V62.756H11.1387V70.0288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.775 19.12H18.4114V15.4837V11.8473V8.21094H14.775H11.1387H7.50232V11.8473V15.4837V19.12H11.1387H14.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4113 84.5748H14.775V88.2112H18.4113V84.5748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4113 55.4835H14.775V59.1199H18.4113V55.4835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 33.6653V30.0289H14.775H11.1387V33.6653H14.775V37.3017V40.938H18.4114V37.3017V33.6653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 95.4838H0.229584V120.938H25.6841V95.4838H18.4114ZM22.0478 102.756V117.302H3.86595V99.1201H22.0478V102.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 88.2108V91.8472H22.0478H25.6842V88.2108H22.0478H18.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0478 40.9386H18.4114V44.575H22.0478V40.9386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 84.5745V80.9381H22.0478H18.4114V84.5745H22.0478H25.6842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 44.5746H22.0479V48.2109H25.6842V44.5746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 37.3019H22.0479V40.9382H25.6842V37.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3206 77.3015V73.6652H25.6842H22.0479V77.3015H25.6842V80.9379H29.3206V77.3015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3205 99.1201V102.756H32.9569V99.1201V95.4838H29.3205V99.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9569 44.5746V48.211H36.5933V44.5746V40.9382H40.2296V37.3019H36.5933H32.9569V40.9382H29.3205H25.6842V44.5746H29.3205H32.9569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9569 37.3018V33.6655V30.0291H36.5933V26.3927V22.7564H40.2297V19.12H43.866V15.4837H47.5024V19.12H51.1388V15.4837V11.8473H47.5024H43.866H40.2297V15.4837H36.5933V19.12H32.9569H29.3206V22.7564H32.9569V26.3927H29.3206V30.0291H25.6842H22.0479V33.6655H25.6842V37.3018H29.3206H32.9569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5933 59.1201H32.9569V62.7565H36.5933V59.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5932 51.8469V55.4833H40.2296H43.866H47.5023V51.8469H43.866H40.2296V48.2106H36.5932V51.8469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2296 8.21094H36.5932V11.8473H40.2296V8.21094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2296 4.57472V8.21108H43.866H47.5024H51.1387V11.8474H54.7751V8.21108H58.4115H62.0478H65.6842V11.8474H69.3205V8.21108H72.9569H76.5933V11.8474V15.4838H80.2296V11.8474H83.866V8.21108H80.2296V4.57472H83.866V0.938354H80.2296H76.5933V4.57472H72.9569H69.3205V0.938354H65.6842V4.57472H62.0478H58.4115H54.7751H51.1387V0.938354H47.5024V4.57472H43.866V0.938354H40.2296H36.5933H32.9569V4.57472V8.21108H36.5933V4.57472H40.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.866 102.756H40.2296V106.393H36.5932H32.9569H29.3205V110.029H32.9569H36.5932H40.2296V113.665H36.5932V117.302H32.9569H29.3205V120.938H32.9569H36.5932H40.2296V117.302H43.866V113.665V110.029H47.5023V106.393H43.866V102.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8659 62.7562H40.2296V66.3926H43.8659V62.7562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8659 33.6656H40.2296V37.302H43.8659V33.6656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5023 59.1201H43.866V62.7565H47.5023V59.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5023 37.3019H43.8659V40.9382H40.2296V44.5746V48.211H43.8659V44.5746H47.5023H51.1386V40.9382H47.5023V37.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1388 117.302H47.5024V120.938H51.1388V117.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5024 77.3021V80.9385H51.1388H54.7752V77.3021H51.1388H47.5024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1388 48.2106H47.5024V51.8469H51.1388V48.2106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7751 95.4838H51.1387V99.1201H54.7751V95.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7751 55.4839V59.1203H51.1387V62.7566H47.5023V66.393H43.866V70.0294H47.5023H51.1387V73.6657H54.7751V70.0294H58.4114V66.393H54.7751V62.7566H58.4114V66.393H62.0478V62.7566H65.6841V59.1203H69.3205V55.4839H65.6841V51.8475H62.0478V55.4839H58.4114V51.8475H54.7751V55.4839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 95.4838H58.4114V99.1201V102.756H62.0477V106.393H65.6841H69.3205H72.9568V102.756H69.3205H65.6841V99.1201H62.0477V95.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0478 91.8469V88.2106H58.4114V84.5742H54.7751H51.1387H47.5023V88.2106V91.8469H43.866H40.2296H36.5933V88.2106H40.2296H43.866V84.5742V80.9378V77.3015V73.6651V70.0287H40.2296V66.3924H36.5933H32.9569H29.3205V62.756V59.1197V55.4833H32.9569V51.8469H29.3205V48.2106H25.6842V51.8469H22.0478V48.2106H18.4114V51.8469V55.4833H22.0478H25.6842V59.1197H22.0478H18.4114V62.756V66.3924H22.0478V62.756H25.6842V66.3924H22.0478V70.0287H25.6842H29.3205V73.6651H32.9569H36.5933V77.3015H40.2296V80.9378H36.5933V77.3015H32.9569V80.9378H29.3205V84.5742H25.6842V88.2106H29.3205V91.8469H32.9569V95.4833H36.5933V99.1197H40.2296V95.4833H43.866V99.1197V102.756H47.5023V106.392H51.1387H54.7751V102.756H51.1387V99.1197H47.5023V95.4833H51.1387V91.8469V88.2106H54.7751V91.8469V95.4833H58.4114V91.8469H62.0478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 77.3021H58.4114V80.9385H62.0477V77.3021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 70.0292H58.4114V73.6655H62.0477V70.0292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4114 22.7564V19.12H54.7751H51.1387V22.7564H47.5023H43.866V26.3927V30.0291V33.6654H47.5023H51.1387V30.0291H47.5023V26.3927H51.1387V30.0291H54.7751V26.3927H58.4114H62.0478V22.7564H58.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4114 11.8473V15.4837V19.12H62.0477V15.4837H65.6841V11.8473H62.0477H58.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0478 110.029V113.666V117.302H58.4114V113.666V110.029H54.7751H51.1387V113.666V117.302H54.7751V120.938H58.4114H62.0478H65.6842H69.3205V117.302H65.6842V113.666H69.3205V110.029H65.6842H62.0478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6842 19.12H62.0478V22.7564H65.6842V19.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6842 80.9385H62.0478V84.5749H65.6842H69.3205V80.9385V77.3021H65.6842V80.9385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9568 73.6652H69.3204V77.3015H72.9568V73.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3205 66.3928H65.6841V70.0292H69.3205H72.9569V66.3928V62.7565V59.1201H69.3205V62.7565V66.3928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 117.302H72.9568V120.938H76.5932V117.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 110.029H80.2296V106.393H76.5932H72.9568V110.029H76.5932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 70.0292H72.9568V73.6655H76.5932V70.0292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5933 113.666V117.302H80.2297V120.938H83.866V117.302H87.5024V113.666H83.866V110.029H80.2297V113.666H76.5933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2297 62.7562H76.5933V66.3926V70.029H80.2297H83.866V66.3926H80.2297V62.7562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2296 59.1199V55.4835H76.5932H72.9568V59.1199H76.5932H80.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8659 59.1201H80.2296V62.7565H83.8659V59.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.866 77.3019H87.5023V73.6655V70.0292H83.866V73.6655V77.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 62.7562H83.866V66.3926H87.5023V62.7562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 8.21108H91.1387V4.57472H94.7751V0.938354H91.1387H87.5023V4.57472H83.866V8.21108H87.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 117.302H87.5023V120.938H91.1387V117.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 113.665H91.1387V110.029V106.393H87.5023H83.866V110.029H87.5023V113.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5024 80.9385H83.866V84.5749H87.5024V88.2112H83.866H80.2296V84.5749V80.9385H76.5933H72.9569V84.5749H76.5933V88.2112V91.8476H72.9569V88.2112H69.3205V91.8476H65.6842H62.0478V95.4839H65.6842V99.1203H69.3205V95.4839H72.9569V99.1203H76.5933V95.4839H80.2296V99.1203H83.866V95.4839H87.5024V99.1203V102.757H91.1387V99.1203V95.4839V91.8476H94.7751V88.2112H91.1387V84.5749V80.9385V77.3021H87.5024V80.9385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 40.9382H83.8659V44.5746V48.211H80.2296V51.8473H83.8659V55.4837H87.5023V51.8473V48.211H91.1387V44.5746H94.775V48.211H98.4114V51.8473H94.775V48.211H91.1387V51.8473V55.4837H87.5023V59.1201V62.7564H91.1387V59.1201H94.775H98.4114V62.7564H102.048V59.1201V55.4837H105.684H109.32V59.1201H105.684V62.7564H102.048V66.3928V70.0292H105.684V66.3928H109.32H112.957V62.7564V59.1201H116.593V55.4837H120.23V51.8473H116.593V48.211H112.957V51.8473H109.32H105.684V48.211H102.048V44.5746H105.684V40.9382H102.048H98.4114H94.775V37.3019H91.1387V40.9382H87.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4114 22.7568H94.775V26.3932H98.4114V22.7568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4114 91.8476H102.048V88.2112V84.5748H98.4114H94.775V88.2112H98.4114V91.8476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.048 73.6658H98.4114V70.0294V66.3931H94.7751V70.0294V73.6658H91.1387V77.3022H94.7751H98.4114H102.048H105.684V73.6658H102.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.684 102.756H102.048V106.393V110.029V113.665H105.684H109.321H112.957V110.029V106.393V102.756H109.321H105.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 88.2108H105.684V91.8472H109.321V88.2108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 77.3021H105.684V80.9385H109.321V77.3021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 70.0292H105.684V73.6655H109.321V70.0292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 44.5746H105.684V48.2109H109.321V44.5746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 37.3019H105.684V40.9382H109.321V37.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.684 22.7565V19.1202H112.957V8.21108H105.684V11.8474H102.048V15.4838H98.4114V8.21108H105.684V0.938354H98.4114V4.57472H94.7751V11.8474H91.1387V15.4838H87.5023V19.1202H83.866V15.4838H80.2296V22.7565H76.5933V26.3929H72.9569V33.6656H69.3205V37.302H72.9569V40.9384H65.6842V33.6656H69.3205V26.3929H72.9569V19.1202H69.3205V22.7565H65.6842V26.3929H62.0478V33.6656H51.1387V40.9384H54.7751V37.302H58.4114V40.9384H54.7751V44.5747H58.4114V51.8474H62.0478V44.5747H65.6842V48.2111H69.3205V51.8474H76.5933V44.5747H80.2296V37.302H76.5933V33.6656H80.2296V30.0293H83.866V26.3929H87.5023V30.0293H83.866V37.302H91.1387V33.6656H105.684V26.3929H109.321V22.7565H105.684ZM102.048 30.0293H91.1387V19.1202H102.048V30.0293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 88.2108H112.957H116.593V84.5745H120.23V80.9381H116.593H112.957H109.321V84.5745V88.2108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 73.6652H109.321V77.3015H112.957V73.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 0.938354H109.321V4.57472H112.957V0.938354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 95.4838H94.775V120.938H120.23V95.4838H112.957ZM116.593 102.756V117.302H98.4114V99.1201H116.593V102.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 88.2108H116.593V91.8472H120.23V88.2108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.593 66.3928V70.0292H120.23V66.3928V62.7565V59.1201H116.593V62.7565V66.3928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.593 30.0293H112.957V26.3929H109.321V30.0293V33.6657H112.957V37.302V40.9384V44.5748H116.593H120.23V40.9384H116.593V37.302H120.23V33.6657V30.0293V26.3929H116.593V30.0293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 15.4839H116.593V19.1202H120.23V15.4839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 4.57434H116.593V8.2107H120.23V4.57434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_9972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.229584 0.938354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidQrCode);
export default __webpack_public_path__ + "static/media/android-qr-code.d300ff87ffba1b8460fd7361dbdda5ea.svg";
export { ForwardRef as ReactComponent };